import { useState } from "react";

import {
    Box,
    SimpleGrid,
    Text,
    Flex,
} from "@chakra-ui/react";
import {
    useNavigate,
} from "react-router-dom";

import routes from "../../../routes";
import {
    Users,
    Wallet,
    User,
    LifeBuoy,
    ArrowRight,
} from "lucide-react";


import SupportTicketModal from "./SupportTicketModal";

const cards = [
    {
        title: "Recruitment & Referrals",
        description:
            "Learn how referral codes work, recruit new drivers, and track referral milestones.",
        action: "Learn More",
        icon: Users,
    },
    {
        title: "Commissions & Payouts",
        description:
            "Find answers about commission earnings, payout schedules, and payment methods.",
        action: "Learn More",
        icon: Wallet,
    },
    {
        title: "Partner Account",
        description:
            "Get help updating your profile, payment details, and account settings.",
        action: "Learn More",
        icon: User,
    },
];

const QuickActions = () => {
    const navigate =
    useNavigate();
    const [isOpen, setIsOpen] =
        useState(false);

    const [category, setCategory] =
        useState(
            "RECRUITMENT_AND_REFERRALS"
        );

    return (
        <>
            <SimpleGrid
                columns={{
                    base: 1,
                    md: 2,
                    xl: 4,
                }}
                gap={4}
            >
                {cards.map((card) => (
                    <Box
                        key={card.title}
                        bg="white"
                        p={{
                            base: 5,
                            md: 6,
                        }}
                        borderRadius="16px"
                        border="1px solid"
                        borderColor="gray.200"
                        h="100%"
                    >
                        <card.icon
                            size={22}
                            color="#2453FF"
                        />

                        <Text
                            fontWeight="700"
                            mt={4}
                            mb={3}
                            fontSize={{
                                base: "md",
                                md: "lg",
                            }}
                        >
                            {card.title}
                        </Text>

                        <Text
                            fontSize="sm"
                            color="gray.500"
                            mb={5}
                            lineHeight="1.7"
                        >
                            {card.description}
                        </Text>

                       <Flex
                        align="center"
                        gap={2}
                        color="#2453FF"
                        fontWeight="600"
                        cursor="pointer"
                        onClick={() =>
                            navigate(
                                routes.supportHelp
                            )
                        }
                    >
                        <Text>
                            {card.action}
                        </Text>

                        <ArrowRight
                            size={16}
                        />
                    </Flex>
                    </Box>
                ))}

                <Box
                    bg="#2453FF"
                    color="white"
                    p={{
                        base: 5,
                        md: 6,
                    }}
                    borderRadius="16px"
                    boxShadow="lg"
                    h="100%"
                >
                    <LifeBuoy
                        size={22}
                    />

                    <Text
                        fontWeight="700"
                        mt={4}
                        mb={3}
                        fontSize={{
                            base: "md",
                            md: "lg",
                        }}
                    >
                        Contact Support
                    </Text>

                    <Text
                        fontSize="sm"
                        mb={5}
                        opacity={0.9}
                        lineHeight="1.7"
                    >
                        Need help with referrals,
                        commissions, payouts,
                        or your partner account?
                        Our support team is here
                        to help.
                    </Text>

                    <Flex
                        align="center"
                        gap={2}
                        fontWeight="600"
                        cursor="pointer"
                        onClick={() =>
                            setIsOpen(
                                true
                            )
                        }
                    >
                        <Text>
                            Send Request
                        </Text>

                        <ArrowRight
                            size={16}
                        />
                    </Flex>
                </Box>
            </SimpleGrid>

            <SupportTicketModal
                isOpen={isOpen}
                onClose={() =>
                    setIsOpen(false)
                }
                category={category}
                setCategory={
                    setCategory
                }
            />
        </>
    );
};

export default QuickActions;